import ScoreTable from "./ScoreTable";
const Scores = () => {
  const handleView = (score) => {
    console.log("View score:", score);
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-900">
            Score Management
          </h2>
        </div>

        <ScoreTable onView={handleView} />
      </div>
    </div>
  );
};

export default Scores;
